import React, { Component } from 'react'
import classNames from 'classnames'
import CommonIcons from 'frontend/components/common-icons'

export default class MapDetails extends Component {
  constructor (props) {
    super(props)
    this.state = {
      location: props.location,
      previousLocation: props.previousLocation,
      nextLocation: props.nextLocation
    }
  }

  UNSAFE_componentWillReceiveProps (nextProps) {
    var nextState = this.state
    var changed = false
    if (nextProps.location !== this.state.location) {
      nextState.location = nextProps.location
      changed = true
    }

    if (nextProps.previousLocation !== this.state.previousLocation) {
      nextState.previousLocation = nextProps.previousLocation
      changed = true
    }

    if (nextProps.nextLocation !== this.state.nextLocation) {
      nextState.nextLocation = nextProps.nextLocation
      changed = true
    }

    if (changed) {
      this.setState(nextState)
    }
  }

  handleSelect (location) {
    if (this.props.onSelect) {
      this.props.onSelect(location)
    }
  }

  renderPreviousLocation () {
    if (this.state.previousLocation) {
      return (
        <div className="previous">
          <button
            onClick={() => {
              this.handleSelect(this.state.previousLocation)
            }}
          >
            <CommonIcons item="common-angle-left" className="icon" />
            previous
          </button>
          <div className="name">{this.state.previousLocation.name}</div>
        </div>
      )
    }
  }

  renderNextLocation () {
    if (this.state.nextLocation) {
      return (
        <div className="next">
          <button
            onClick={() => {
              this.handleSelect(this.state.nextLocation)
            }}
          >
            <CommonIcons item="common-angle-right" className="icon" />
            next
          </button>
          <div className="name">{this.state.nextLocation.name}</div>
        </div>
      )
    }
  }

  renderRooms () {
    if (this.state.location && this.state.location.rooms && this.state.location.rooms.length > 0) {
      return (
        <div className="rooms">
          <h3 className="title">Rooms</h3>
          {this.state.location.rooms.map(function (room) {
            if (room.pageOpened) {
              return (
                <div key={room.id} className="room">
                  {room.image && (
                    <a href={room.path}>
                      <img className="image" src={room.image.xsmallSquare} />
                    </a>
                  )}
                  <a href={room.path} className="name">
                    {room.name}
                  </a>
                </div>
              )
            } else {
              return (
                <div key={room.id} className="room">
                  {room.image && <img className="image" src={room.image.xsmallSquare} />}
                  <span className="name">{room.name}</span>
                </div>
              )
            }
          })}
        </div>
      )
    }
  }

  renderDetails () {
    if (this.state.location) {
      return (
        <div className="fix_wrap">
          <div className="location_name">{this.state.location.name}</div>
          <div className="prev_next_location_navigation">
            {this.renderPreviousLocation()}
            {this.renderNextLocation()}
          </div>
          <div className="contacts">
            <h3 className="title">Contacts</h3>
            <div className="address">
              <div className="title">
                <CommonIcons item="common-map-marker-alt" className="icon" />
                Address:
              </div>
              <div className="value">
                <a href={this.state.location.mapUrl} target="_blank" rel="noopener noreferrer">
                  {this.state.location.address.local}
                </a>
              </div>
            </div>
            <div className="phone">
              <div className="title">
                <CommonIcons item="common-phone" className="icon" />
                Phone:
              </div>
              <div className="value">{this.state.location.phone}</div>
            </div>
          </div>
          {this.renderRooms()}
          <div className="more_info_link">
            <a href={this.state.location.path}>More info</a>
          </div>
        </div>
      )
    }
  }

  render () {
    return (
      <div
        id="location_details"
        className={classNames([
          'location_details',
          'off-canvas',
          'in-canvas-for-small',
          'position-right',
          this.state.location ? 'is-open' : 'is-closed'
        ])}
        data-off-canvas="data-off-canvas"
        data-transition="overlap"
      >
        <button
          className="close-button"
          onClick={() => {
            this.setState({ location: null })
          }}
        >
          <CommonIcons item="common-times" className="icon icon_for_mobile" />
          <CommonIcons item="common-angle-right" className="icon" />
        </button>
        {this.renderDetails()}
      </div>
    )
  }
}
